export interface GetDiagnosticsAnswersParams {
  projectId: string
}

export interface GetDiagnosticsResultParams {
  projectId: string
}

const endpoints = {
  getQuestion: 'Api/project_diag_create_block',
  getBlocks: 'Api/project_diag_create_block',
  createBlock: 'Api/project_diag_create_block.php',
  getAnswers: ({ projectId }: GetDiagnosticsAnswersParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/diagnostic/answers`
  },
  getResult: ({ projectId }: GetDiagnosticsAnswersParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/diagnostic/result`
  },
}

export default endpoints
